import styled, { keyframes } from "styled-components"
import { Link } from "react-router-dom"

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(-10px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-5px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`

export const CategoriesStyled = styled.div`
    position: absolute;
    top: 50px;
    left: 0;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    width: 280px;
    box-shadow:
            0 20px 25px -5px rgba(0, 0, 0, 0.1),
            0 10px 10px -5px rgba(0, 0, 0, 0.04);
    z-index: 1000;
    overflow: visible; /* Изменено с hidden на visible */
    backdrop-filter: blur(10px);
    animation: ${fadeIn} 0.2s ease-out;

    @media (max-width: 768px) {
        position: fixed;
        top: 60px;
        left: 10px;
        right: 10px;
        width: auto;
        max-height: calc(100vh - 80px);
        overflow-y: auto;
    }

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
    }

    ul {
        list-style: none;
        padding: 8px 0;
        margin: 0;
    }
`

export const CategoryItem = styled.li`
    position: relative;
    margin: 2px 8px;
    border-radius: 8px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        transform: ${(props) => (props.$isMobile ? "none" : "translateX(2px)")};

        .chevron-icon {
            transform: ${(props) => (props.$isMobile ? "none" : "translateX(2px)")};
            color: #3b82f6;
        }
    }

    .chevron-icon {
        transition: all 0.2s ease;

        &.rotated {
            transform: rotate(90deg);
        }
    }

    ${(props) =>
            props.$hasSubcategories &&
            `
        &::after {
            content: '';
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            width: 2px;
            height: 2px;
            background: #94a3b8;
            border-radius: 50%;
            opacity: 0.6;
        }
    `}
`

export const CategoryLink = styled(Link)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    text-decoration: none;
    color: #334155;
    font-weight: 500;
    font-size: 14px;
    transition: all 0.2s ease;
    border-radius: 8px;

    span {
        flex: 1;
        font-weight: 500;
        letter-spacing: -0.01em;
    }

    .chevron-icon {
        color: #94a3b8;
        transition: all 0.2s ease;
        margin-left: 8px;
    }

    &:hover {
        color: #1e293b;

        span {
            font-weight: 600;
        }
    }
`

export const SubCategoriesStyled = styled.div`
    position: ${(props) => (props.$isMobile ? "static" : "absolute")};
    top: ${(props) => (props.$isMobile ? "auto" : "-8px")};
    left: ${(props) => (props.$isMobile ? "auto" : "calc(100% + 8px)")};
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    width: ${(props) => (props.$isMobile ? "auto" : "240px")};
    margin: ${(props) => (props.$isMobile ? "8px 16px 0 16px" : "0")};
    box-shadow: 
        0 20px 25px -5px rgba(0, 0, 0, 0.1),
        0 10px 10px -5px rgba(0, 0, 0, 0.04);
    overflow: hidden;
    animation: ${(props) => (props.$isMobile ? fadeIn : slideIn)} 0.2s ease-out;
    backdrop-filter: blur(10px);
    z-index: 1001;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: linear-gradient(90deg, transparent, #e2e8f0, transparent);
    }

    ul {
        list-style: none;
        padding: 8px 0;
        margin: 0;
    }

    li {
        margin: 2px 8px;
        border-radius: 8px;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
            background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
            transform: ${(props) => (props.$isMobile ? "none" : "translateX(2px)")};
        }

        a {
            display: block;
            padding: 10px 16px;
            text-decoration: none;
            color: #475569;
            font-size: 13px;
            font-weight: 500;
            transition: all 0.2s ease;
            border-radius: 8px;
            letter-spacing: -0.01em;

            &:hover {
                color: #1e293b;
                font-weight: 600;
            }

            &::before {
                content: '•';
                color: #94a3b8;
                margin-right: 8px;
                font-size: 12px;
                transition: color 0.2s ease;
            }

            &:hover::before {
                color: #3b82f6;
            }
        }
    }
`
